import Image from "next/image";
import { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import { IconButton, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TopListLayout } from "./mobile-top-list";
import { useStyle } from "./style";
import { convertHeightToVH } from "@/utils/adapter";
import { HEADER_HEIGHT } from "@/utils/layout-config";
import { useTheme } from "@/contexts/theme";
import { HpLogoIcon } from "@/themes/hp-client/icons/HpLogoIcon";
import { HeaderActions } from "@/widgets/header/components/header-actions/header-actions";
import { LineOfBusinessSelector } from "@/widgets/header/components/line-of-business-selector/line-of-business-selector";
import { UserProfileMenu } from "@/widgets/header/components/user-profile-menu/user-profile-menu";

const MobileHeaderWidget = () => {
  const { classes } = useStyle();
  const { t } = useTranslation();
  const { currentTheme } = useTheme();
  const isHpClient = currentTheme === "hp-client";
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const logoSize = parseFloat(convertHeightToVH(HEADER_HEIGHT)) * 0.6;

  return (
    <div style={{ position: "relative" }}>
      {/* Header */}
      <div style={classes.mobileHeaderContainer}>
        {isHpClient ? (
          <HpLogoIcon width={32} height={32} />
        ) : (
          <Image
            src={
              "https://gomake-printhouses-logos.s3.amazonaws.com/default_generalLogo.jpeg"
            }
            alt="logo"
            width={logoSize}
            height={logoSize}
            style={{
              objectFit: "contain",
              borderRadius: "4px",
              width: `${logoSize}vh`,
              height: `${logoSize}vh`,
              flexShrink: 0,
            }}
          />
        )}

        <Stack direction="row" alignItems="center" gap="2px" minWidth={0}>
          <HeaderActions compact />
          <LineOfBusinessSelector variant="icon" />
          {/* Matches the 26px action chips (18px icon + 4px padding). */}
          <UserProfileMenu avatarSize={26} />
          <IconButton
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            aria-label={t("general.menu")}
            aria-expanded={isSidebarOpen}
            sx={{ padding: "4px" }}
          >
            {isSidebarOpen ? (
              <CloseIcon sx={{ color: "#f6f6f6", width: 20, height: 20 }} />
            ) : (
              <MenuRoundedIcon
                sx={{ color: "#f6f6f6", width: 20, height: 20 }}
              />
            )}
          </IconButton>
        </Stack>
      </div>

      <div
        style={{
          ...classes.drawerContainer,
          height: isSidebarOpen ? "60vh" : "0px",
        }}
      >
        <TopListLayout />
      </div>
    </div>
  );
};

export { MobileHeaderWidget };
